<template>
  <div class="bar fl ">
    <div :id="id" style="width: 100%;height:300px; padding:24px;padding-bottom: 0;" v-if="detail.length"></div>
    <!-- <div v-if="loading" class="demo-loading-container">
      <a-spin />
    </div>
    <div v-if="!detail.length&&!loading" class="demo-loading-container">
      <a-empty />
    </div> -->
  </div>
</template>

<script>
  import {contractMonitor} from '../../../api/contract.js'
  import echarts from 'echarts'
  export default {
    name: "bar",
    components: {},
    data() {
      return {
        id: "bar" + Math.random(),
        flag: true,
        detail:[],
        loading: false
      }
    },
    methods: {
      getMonitor(){
        this.loading = true
        contractMonitor().then(res => {
          let data = res.data
          if (data.code === '000') {
            this.detail = data.content
            this.$nextTick(function () {
              this.initEcharts()
            })
          } else {
            this.detail = []
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
      initEcharts() {
        let data = this.detail
        if (!this.flag) {
          return false
        }
        let legendData=[]
        let legendNum=[]
        let shadowDate = []
        for (let i = 0; i < data.length; i++) {
          if(!data[i].count) {
            data[i].count = 0
          }
            legendData.push(data[i].month)
            legendNum.push(data[i].count)
        }
        if(legendData.length>0){
          for(let i in legendData){
            if(i % 2 == 0){
              shadowDate.push(12)
            }else{
              shadowDate.push(0)
            }
          }
        }
        this.$nextTick(function () {
          this.flag = false
          var myChart = echarts.init(document.getElementById(this.id));
          let option = {
            backgroundColor: '#fff',
            color: ['#3398DB'],
            title: {
              text:"到期监控图",
              textStyle:{
                  fontSize:14,
                  padding:"10px"
              }
            },
            grid: {
                show: true,
                left: "3%",
                top: "12%",
                right: "3%",
                border: 0,
                borderWidth: 0
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
        
            xAxis: [
                {
                    type: 'category',
                    position: 'bottom',
                    interval: 0,
                    axisLine: {
                        show: true,
                        onZero: true,
                        lineStyle: {
                            color: "#556477"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        interval: 0,
                        color: "#000",
                        fontFamily: 'Microsoft YaHei',
                        fontSize: 12,
                        //rotate: 60
                        formatter : function(params){
                          var newParamsName = "";// 最终拼接成的字符串
                          var paramsNameNumber = params.length;// 实际标签的个数
                          var provideNumber = 4;// 每行能显示的字的个数
                          var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                          /**
                           * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                           */
                          // 条件等同于rowNumber>1
                          if (paramsNameNumber > provideNumber) {
                            /** 循环每一行,p表示行 */
                            var tempStr = "";// 表示每一次截取的字符串
                            var tempFist = "";// 开始截取的位置
                            tempFist = params.substring(0, 4) + "\n";
                            tempStr = params.substring(5, 8) + "\n";
                            newParamsName = tempFist + tempStr;// 最终拼成的字符串

                          } else {
                            // 将旧标签的值赋给新标签
                            newParamsName = params;
                          }
                          //将最终的字符串返回
                            return newParamsName
                        }
                    },
                    data: legendData,
                    axisPointer: {
                        type: 'shadow'
                    },
                }
            ],
            yAxis: [{
                textStyle:{
                  fontSize:25
                },
                type: 'value',
                minInterval: 1,
                axisLine: {
                    lineStyle: {
                        color: 'rgba(107,107,107,0.37)',
                    }
                },
                }
            ],
            series: [
                {
                    name: '到期合同',
                    type: 'bar',
                    data: legendNum,// [10, 52, 200, 334, 390, 330, 220]
                    barWidth: '30px',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#1c3faa' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#2196f3' // 100% 处的颜色
                            }], false),
                            // barBorderRadius: [30, 30, 30, 30],
                            shadowColor: 'rgba(0,160,221,1)',
                            shadowBlur: 4,
                        }
                    },
                }
            ],

          };
          myChart.setOption(option)
          myChart.on('click', (params) =>{
            if(params.name){
              this.$router.push({path:'/contractManagement/contractDetail',query:{time:params.name}})
            }
          })
        })
      }
    },

    created() {
      this.getMonitor()
    },
    mounted() {

    },
  }
</script>

<style scoped lang="scss">
  .bar {
    width: 100%;
    background: #fff;
    border: 1px solid #f0f2f5;
    min-height: 300px;
    position: relative;
    .title {
      font-size: 22px;
      color: #3B4859;
      font-weight: 700;
      width: 600px;
      padding-left:24px;
      padding-top: 30px;
    }
    .demo-loading-container {
      position: absolute;
      bottom: 80px;
      width: 100%;
      text-align: center;
    }
  }
</style>
